var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAutodiscoverOff(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    transform: "translate(0 -0.000488281)",
    fill: "white",
    style: {
      mixBlendMode: "multiply"
    }
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.8868 11.4722C13.7099 10.3177 14.097 8.90874 13.9794 7.49574C13.8618 6.08273 13.2471 4.75717 12.2445 3.75461C11.2418 2.75204 9.91622 2.1374 8.5032 2.01989C7.09019 1.90239 5.68127 2.28963 4.52681 3.11281L12.8868 11.4722Z",
    fill: "#DA1E28"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3.11281 4.52681C2.28971 5.68134 1.90257 7.09028 2.02017 8.50329C2.13778 9.91629 2.75252 11.2419 3.75516 12.2444C4.75779 13.247 6.0834 13.8616 7.49641 13.9791C8.90942 14.0966 10.3183 13.7094 11.4728 12.8862L3.11281 4.52681Z",
    fill: "#DA1E28"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAutodiscoverOff);
export default __webpack_public_path__ + "static/media/autodiscover_off.531d7c5c8955027718f3d947e9411564.svg";
export { ForwardRef as ReactComponent };